import { defineStore } from 'pinia'

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
    const breadcrumb = ref(null)
    const hasBreadcrumb = computed(() => breadcrumb.value !== null)
    const getBreadcrumb = computed(() => breadcrumb.value)

    function setBreadcrumb(value) {
        breadcrumb.value = value
    }

    function clearBreadcrumb() {
        breadcrumb.value = null
    }

    return {
        breadcrumb,
        hasBreadcrumb,
        getBreadcrumb,
        setBreadcrumb,
        clearBreadcrumb,
    }
})
